import UserRoleRow from '../userRoleRow';
import './style.scss';

function UserRolDescription({ itemsDescription, itemUser, userCreated }) {
  return (
    <div className='usersRole-description-container'>
      <div className='description-container'>
        {itemsDescription.length > 0 &&
          itemsDescription.map((itemD, i) => <p key={i}>{itemD.name}</p>)}
      </div>
        <div className="user-list-scroll">
              {itemUser.length > 0 &&
                itemUser.map((item, i) => <UserRoleRow key={i} item={item} userCreated={userCreated} />)}
        </div>
    </div>
  );
}
export default UserRolDescription;